import React from 'react'
import propTypes from 'prop-types'
import Button from 'components/button'
import themeVars from 'theme/themeVars'
import Icon from '../icon'
import {t} from 'helpers/language'

const getStyles = (props) => {
  const {dark, fontSize, height} = props
  const propStyles = props.styles || {}
  const {palette} = themeVars

  let backgroundColor = palette.whiteColor, textColor = palette.primaryFontColor
  if (dark) {
    backgroundColor = palette.contrastBackgroundColor
    textColor = palette.contrastTextColor
  }

  if (props.backgroundColor) backgroundColor = props.backgroundColor
  if (props.textColor) textColor = props.textColor

  const styles = {
    container: {
      backgroundColor,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: height ? height : '100%',
      width: 'initial',
      padding: 24,
    },
    messageContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      display: 'flex',
      flexFlow: 'column',
      padding: 24,
    },
    messageIconWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    messageTitle: {
      color: textColor,
      fontSize: fontSize ? fontSize : 16,
      marginBottom: 12,
      marginTop: 12,
    },
    messageDescription: {
      color: textColor,
      fontSize: fontSize ? fontSize : 16,
      marginBottom: 24,
    },
    placeholderAction: {
      width: 230,
      height: 50,
    },
    actions: {
      display: 'inline-flex',
      listStyleType: 'none',
      margin: 0,
      padding: 0,
    },
    action: {
      margin: '0px 12px',
      boxShadow: 'none',
    },
  }
  return {...styles, ...propStyles}
}

const Placeholder = (props) => {
  const styles = getStyles(props)
  const {palette} = themeVars
  const {dark, isFiltering, isIcon, isSearching, messageDescription, messageIcon, messageTitle} = props

  let actions = props.actions || []
  if (actions !== null) {
    actions = (
      <ul className="actions" style={styles.actions}>
        {actions.map((action, index) => {
          const {title, onClick, ...otherProps} = action
          return (
            <li key={'action_' + index} className="action">
              <Button
                icon={isIcon ? <Icon name="plus-no-margin" size={12} color="white"/> : null}
                label={title}
                className={action.className}
                onClick={onClick}
                style={styles.action}
                primary={true}
                {...otherProps}
              />
            </li>
          )
        })}
      </ul>
    )
  }

  let image
  if (props.image) {
    image = (
      <div className="messageIcon" style={styles.messageIconWrapper}>
        {props.image}
      </div>
    )
  } else {
    const iconSize = props.iconSize ? props.iconSize : 48
    const iconColor = props.iconColor
      ? props.iconColor
      : dark
        ? palette.contrastIconColor || palette.lightIconColor
        : palette.disabledIconColor
    image = (
      <div className="messageIcon" style={styles.messageIconWrapper}>
        <Icon size={iconSize} color={iconColor} name={messageIcon} style={styles.messageIcon}/>
      </div>
    )
  }

  return (
    <div className="placeholderContainer" style={styles.container}>
      <div className="placeholderMessageContainer" style={styles.messageContainer}>
        {image}
        <div className="messageTitle" style={styles.messageTitle}>
          {typeof messageTitle === 'string' ? t(messageTitle) : messageTitle}
        </div>
        {messageDescription
          ? (
            <div className="messageDescription" style={styles.messageDescription}>
              {typeof messageDescription === 'string' ? t(messageDescription) : messageDescription}
            </div>
          )
          : null
        }
        {isFiltering || isSearching
          ? (
            <div className="messageClearSuggestion">
              {t('Try adjusting your search or filter to find what you are looking for')}
            </div>
          )
          : null
        }
      </div>
      {actions}
    </div>
  )
}

Placeholder.propTypes = {
  messageTitle: propTypes.oneOfType([
    propTypes.string,
    propTypes.object,
  ]),
  messageDescription: propTypes.oneOfType([
    propTypes.string,
    propTypes.object,
  ]),
  messageIcon: propTypes.string,
  actions: propTypes.arrayOf(propTypes.shape({
    title: propTypes.string.isRequired,
    onClick: propTypes.func.isRequired,
  })),
  backgroundColor: propTypes.string,
  fontSize: propTypes.number,
  height: propTypes.oneOfType([
    propTypes.string,
    propTypes.number,
  ]),
  dark: propTypes.bool,
  iconSize: propTypes.number,
  iconColor: propTypes.string,
  image: propTypes.element,
  isFiltering: propTypes.bool,
  isSearching: propTypes.bool,
  isIcon: propTypes.bool,
}

Placeholder.defaultProps = {
  isFiltering: false,
  isSearching: false,
  isIcon: false,
}

export default Placeholder
